import { FluidAnchorPosition } from '@lmig/fluid-core';
import { FunctionalComponent, h } from '@stencil/core';

import { FluidFunctionalComponentProps } from '../../../model/functional/fluid-functional-component-props.interface';

interface ContainerProps extends FluidFunctionalComponentProps {
  host?: any;
  render?: boolean;
  position?: FluidAnchorPosition;
  identifier?: string;
}

// ================================================================ //
// -- Public Functional Components

/**
 * ContainerNamedSlots
 */
export const ContainerNamedSlots: FunctionalComponent<ContainerProps> = (
  props
) => {
  const { host } = props;

  return [
    <FixedContentSlot
      render={host._renderSlotTop}
      position={FluidAnchorPosition.TOP}
    />,
    <FixedContentSlot
      render={host._renderSlotBottom}
      position={FluidAnchorPosition.BOTTOM}
    />,
    <FixedContentSlot
      render={host._renderSlotLeft}
      position={FluidAnchorPosition.LEFT}
    />,
    <FixedContentSlot
      render={host._renderSlotRight}
      position={FluidAnchorPosition.RIGHT}
    />,
  ];
};

// ================================================================ //
// -- Private Functional Components

/**
 * FixedContentSlot
 */
const FixedContentSlot: FunctionalComponent<ContainerProps> = (props) => {
  const { render, position, identifier } = props;

  if (!render) return;

  return (
    <div
      class={`fixed-content-${position}`}
      data-test-id={`${identifier}-fixed-${position}`}>
      <slot
        name={`fixed-content-${position}`}
        data-test-id={`${identifier}-slot-fixed-${position}`}
      />
    </div>
  );
};
